/* src/app/components/lead-details/login-details/login-details.component.css */
/*# sourceMappingURL=login-details.component-UOT7UU54.css.map */
